// src/components/ModalNovoServico.jsx
import React from "react";
import { FaWrench, FaStickyNote, FaDollarSign } from "react-icons/fa";

const ModalNovoServico = ({
  open,
  onClose,
  onChange,
  onSave,
  form,
  errors = {},
  editando = false,
}) => {
  if (!open) return null;

  const safeForm = {
    nome: "",
    descricao: "",
    valorSugerido: "",
    ...(form || {}),
  };

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[2px] animate-fadein"
      role="dialog"
      aria-modal="true"
      onClick={handleBackdrop}
    >
      <div
        className="bg-white dark:bg-gray-900 rounded-3xl shadow-2xl w-full max-w-xl relative animate-modalSlideIn overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="max-h-[94vh] flex flex-col">
          {/* Header */}
          <div className="p-7 pb-0 relative">
            <button
              className="absolute right-8 top-7 text-gray-500 hover:text-blue-700 dark:text-gray-200 dark:hover:text-white text-base font-medium"
              onClick={onClose}
            >
              Fechar
            </button>
            <h2 className="text-2xl font-bold mb-6 text-blue-600 dark:text-white">
              {editando ? "Editar Serviço" : "Novo Serviço"}
            </h2>
          </div>

          {/* Body (form rolável) */}
          <form
            id="form-servico"
            className="px-7 pb-6 space-y-6 overflow-y-auto flex-1"
            onSubmit={(e) => {
              e.preventDefault();
              onSave?.();
            }}
          >
            {/* Nome */}
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">
                Nome do serviço
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                  <FaWrench />
                </span>
                <input
                  className="border rounded-xl px-4 py-3 w-full pl-10 focus:ring-2 focus:ring-[#004AAD] transition bg-gray-50 dark:bg-gray-800 dark:text-white dark:border-gray-700"
                  placeholder="Ex: Troca de óleo"
                  value={safeForm.nome}
                  autoFocus
                  required
                  onChange={(e) => onChange?.("nome", e.target.value)}
                />
              </div>
              {errors.nome && (
                <span className="text-red-500 text-xs">{errors.nome}</span>
              )}
            </div>

            {/* Descrição */}
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">
                Descrição
              </label>
              <div className="relative">
                <span className="absolute left-3 top-3 text-gray-400">
                  <FaStickyNote />
                </span>
                <textarea
                  className="border rounded-xl px-4 py-3 w-full pl-10 focus:ring-2 focus:ring-[#004AAD] transition bg-gray-50 dark:bg-gray-800 dark:text-white dark:border-gray-700"
                  placeholder="Descreva o serviço (opcional)"
                  rows={3}
                  value={safeForm.descricao}
                  onChange={(e) => onChange?.("descricao", e.target.value)}
                />
              </div>
            </div>

            {/* Valor sugerido */}
            <div>
              <label className="block text-sm font-semibold mb-1 dark:text-gray-200">
                Valor sugerido (R$)
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                  <FaDollarSign />
                </span>
                <input
                  type="text"
                  inputMode="decimal"
                  className="border rounded-xl px-4 py-3 w-full pl-10 focus:ring-2 focus:ring-[#004AAD] transition bg-gray-50 dark:bg-gray-800 dark:text-white dark:border-gray-700"
                  placeholder="Ex: 80,00"
                  value={safeForm.valorSugerido}
                  onChange={(e) => onChange?.("valorSugerido", e.target.value)}
                />
              </div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 ml-1">
                Campo opcional para sugestão de preço
              </p>
            </div>
          </form>

          {/* Rodapé com separador e botão único */}
          <div className="px-7 py-5 bg-white/95 dark:bg-gray-900/95 backdrop-blur border-t border-gray-200 dark:border-gray-800">
            <button
              type="submit"
              form="form-servico"
              className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-blue-600 px-5 py-3.5 font-semibold text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition"
            >
              {editando ? "Salvar Alterações" : "Cadastrar Serviço"}
            </button>
          </div>
        </div>

        {/* Animações */}
        <style>{`
          .animate-modalSlideIn { animation: modalSlideIn 0.35s cubic-bezier(.32,.72,.57,1) both; }
          @keyframes modalSlideIn {
            0% { opacity:0; transform: translateY(60px) scale(.97);}
            100% { opacity:1; transform: translateY(0) scale(1);}
          }
          .animate-fadein { animation: fadein 0.25s; }
          @keyframes fadein { from { opacity: 0; } to { opacity: 1; } }
        `}</style>
      </div>
    </div>
  );
};

export default ModalNovoServico;
